export default "__VITE_PUBLIC_ASSET__25d1e611__"